import './App.css';
import Password from './components/MainComponent';

const  App = () => {
  return(
      <Password />
  )
}

export default App;
